<template>
  <el-container style="height: 100vh">
    <el-header>
      <navcon></navcon>
    </el-header>
    <el-main style="background-color: #f1f2f7;">
      <div class="personal_box">
        <p class="personal_title">
          <span @click="tabIndex=0" id="essential_information_title" :class="tabIndex?'':'title_select'">基本信息</span>
          <span @click="tabIndex=1" id="change_pwd_title" :class="tabIndex?'title_select':''">修改密码</span>
        </p>
        <!--基本信息内容-->
        <div class="personal_content" id="essential_information" v-show="tabIndex==0">
          <el-form ref="form" label-width="80px">
            <el-form-item label="账户名：">
              <p style="font-size: 16px;margin: 0">{{user_phone}}</p>
            </el-form-item>
            <el-form-item label="头像：">
              <el-upload
                class="avatar-uploader"
                action="http://192.168.0.26:10004/images"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :http-request='httprequest'
              >
                <img v-if="file_url" :src="file_url" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item size="small" label="昵称：">
              <el-input v-model="user_name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$router.back(-1)">返回</el-button>
              <el-button type="primary" @click="modify_personal">确认修改</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!--修改密码内容-->
        <div class="personal_content" id="change_pwd" v-show="tabIndex==1">
          <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px"
                   class="demo-ruleForm">
            <el-form-item size="small" label="当前密码：" prop="current_pwd">
              <el-input v-model="oldPwd" style="width: 350px;"></el-input>
            </el-form-item>
            <el-form-item size="small" label="新密码：" prop="pass">
              <!--              <el-input type="password" v-model="ruleForm.pass" autocomplete="off">-->
              <el-input type="password" v-model="pwd_strength" autocomplete="off"
                        placeholder="大小写字母、数字、字符组合更安全" style="width: 350px;">
              </el-input>
            </el-form-item>
            <el-form-item label="密码强度：" prop="pwd_strength" class="pwd_strength">
              <span id="pwd_strength_weak"></span>
              <span id="pwd_strength_middle" style="display: none"></span>
              <span id="pwd_strength_strong" style="display: none"></span>
            </el-form-item>
            <el-form-item size="small" label="确认密码：" prop="check_pass">
              <el-input type="password" v-model="new_password" autocomplete="off"
                        placeholder="请再次输入新密码" style="width: 350px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$router.back(-1)">返回</el-button>
              <el-button type="primary" @click="modify_change_pwd">提交</el-button>
            </el-form-item>
            <div class="forget" @click="$router.push('/forget')">忘记密码?点击这里</div>
          </el-form>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
    // 导入组件
    import navcon from '../components/navcon.vue'
    // 注册组件
    export default {
        // name: 'personal',
        inject: ['reload'],
        // 注册组件
        components: {
            navcon
        },
        data() {
            // var validatePass = (rule, value, callback) => {
            //     if (value === '') {
            //         callback(new Error('请输入密码'));
            //     } else {
            //         if (this.ruleForm.checkPass !== '') {
            //             this.$refs.ruleForm.validateField('checkPass');
            //         }
            //         callback();
            //     }
            // };
            // var validatePass2 = (rule, value, callback) => {
            //     if (value === '') {
            //         callback(new Error('请再次输入密码'));
            //     } else if (value !== this.pwd_strength) {
            //         callback(new Error('两次输入密码不一致!'));
            //     } else {
            //         callback();
            //     }
            // };
            return {
                ruleForm: {
                    pass: '',
                    checkPass: '',
                    current_pwd: ''
                },
                // rules: {
                //     pwd_strength: [
                //         {validator: validatePass, trigger: 'blur'}
                //     ],
                //     checkPass: [
                //         {validator: validatePass2, trigger: 'blur'}
                //     ]
                // },

                // 头像
                file_url: '',
                // 个人信息
                user_phone: '',
                user_id: '',
                login_pwd: '',
                oldPwd: '',
                new_password: '',
                user_name: '',
                // 密码强度
                msgText: '',
                pwd_strength: '',
                tabIndex:0
            };
        },
        methods: {
            // 基本信息修改密码的切换
            // switch_title(id) {
            //     let essential_information_title = document.querySelector('#essential_information_title')
            //     let change_pwd_title = document.querySelector('#change_pwd_title')
            //     let essential_information = document.querySelector('#essential_information')
            //     let change_pwd = document.querySelector('#change_pwd')
            //     if (id == 1) {
            //         essential_information_title.className = ''
            //         change_pwd_title.className = 'title_select'
            //         essential_information.style.display = ''
            //         change_pwd.style.display = 'none'
            //     } else if (id == 2) {
            //         essential_information_title.className = 'title_select'
            //         change_pwd_title.className = ''
            //         essential_information.style.display = 'none'
            //         change_pwd.style.display = ''
            //     }
            // },
            // 获取个人信息数据
            get_personal() {
                var logindata = JSON.parse(sessionStorage.obj);
                this.user_phone = logindata.data.user.user_phone
                this.login_pwd = logindata.data.user.user_password
                this.user_id = logindata.data.user.user_id
                // console.log(logindata)
                // this.image_src = logindata.data.user.images
                // this.user_name = logindata.data.user.user_name
            },
            // 修改基本信息
            modify_personal() {
                this.$axios.get(url.auth + 'updateUser', {
                    params: {
                        user_id: this.user_id,
                        images: this.file_url,
                        user_name: this.user_name,
                    }
                }).then(res => {
                    // console.log(this.file_url)
                })
            },
            // 修改旧密码
            modify_change_pwd() {
                this.$axios.get(url.auth + 'updatePwd', {
                    params: {
                        user_id: this.user_id,
                        user_password: this.new_password,
                        oldPwd: this.oldPwd,
                    }
                }).then(res => {
                    console.log(res)
                    this.reload()
                })
            },

            // 密码强度
            checkStrong(sValue) {
                var modes = 0;
                //正则表达式验证符合要求的
                if (sValue.length < 1) return modes;
                if (/\d/.test(sValue)) modes++; //数字
                if (/[a-z]/.test(sValue)) modes++; //小写
                if (/[A-Z]/.test(sValue)) modes++; //大写
                if (/\W/.test(sValue)) modes++; //特殊字符
                //逻辑处理
                switch (modes) {
                    case 1:
                        return 1;
                        break;
                    case 2:
                        return 2;
                        break;
                    case 3:
                    case 4:
                        return sValue.length < 4 ? 3 : 4;
                        break;
                }
                return modes;
            },

            // submitForm(formName) {
            //     this.$refs[formName].validate((valid) => {
            //         if (valid) {
            //             alert('submit!');
            //         } else {
            //             console.log('error submit!!');
            //             return false;
            //         }
            //     });
            // },

            // 头像
            handleRemove(file) {
                console.log(file);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleDownload(file) {
                console.log(file);
            },
            // 文件上传
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            httprequest(file) {
                // console.log(file.file)
                var formdata = new FormData()
                formdata.append('file', file.file)
                // console.log(formdata)
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Access-Control-Allow-Origin': '*'
                    }
                }
                // header("Access-Control-Allow-Origin: *");
                this.$axios.post('http://192.168.0.26:10004/images', formdata, config).then(res => {
                    // console.log(res.data)
                    this.file_url = 'http://' + res.data
                    // console.log(this.file_url)
                })
            },

        },
        mounted() {
            this.get_personal()
        },
        watch: {
            // 密码强度
            pwd_strength(newname, oldname) {
                this.msgText = this.checkStrong(newname);
                var pwd_strength_middle = document.getElementById('pwd_strength_middle')
                var pwd_strength_strong = document.getElementById('pwd_strength_strong')
                if (this.msgText > 1 || this.msgText == 1) {
                    pwd_strength_middle.style.display = 'none'
                    pwd_strength_strong.style.display = 'none'
                } else {
                }
                if (this.msgText > 2 || this.msgText == 2) {
                    pwd_strength_middle.style.display = ''
                    pwd_strength_strong.style.display = 'none'
                } else {
                }
                if (this.msgText == 4) {
                    pwd_strength_middle.style.display = ''
                    pwd_strength_strong.style.display = ''
                } else {
                }
            },

        },
    }
</script>
<style scoped>
  .forget{
    text-align: center;
    margin-top: 10px;
    color: #409eff;
    cursor: pointer;
  }
  .el-header{
    padding: 0;
    height: 45px !important;
  }
  /*全局*/
  .personal_box {
    width: 800px;
    background-color: #fff;
    height: 400px;
    margin: 0 auto;
    text-align: center;
    padding: 25px;
  }
  .personal_title span{
    cursor: pointer;
  }
  .personal_title span:nth-child(1) {
    margin-right: 25px;
  }

  .personal_title span:nth-child(2) {
    margin-left: 25px;
  }

  .title_select {
    color: #3c98ff;
    cursor: pointer;
  }

  .personal_content {
    width: 450px;
    margin: 0 auto;
    padding-top: 10px;
    text-align: left;
  }

  /*修改密码*/
  .pwd_strength {
    text-align: left;
  }

  .pwd_strength span {
    display: inline-block;
    width: 100px;
    height: 13px;
    border-radius: 8px;
  }

  .pwd_strength #pwd_strength_weak {
    background-color: #D82A23;
  }

  .pwd_strength #pwd_strength_middle {
    background-color: #EF9929;
  }

  .pwd_strength #pwd_strength_strong {
    background-color: #7CB70D;
  }

  /*头像*/
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px solid #dedede;
    border-radius: 4px;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>
